import { createFileRoute, Outlet } from '@tanstack/react-router';
import { DeliveryNotes } from '@/pages/delivery-notes';
import { RoleGuard } from '@/components/molecules/role-guard';
import { usePermissions } from '@/hooks/use-permissions';
import { documentsSearchSchema } from '@/routes/protected/_layout/documents/_layout';

export const Route = createFileRoute(
  '/protected/_layout/delivery-notes/_layout'
)({
  validateSearch: documentsSearchSchema,
  component: DeliveryNotesLayout,
});

function DeliveryNotesLayout() {
  const { canAccessDeliveryNotes, isLoading } = usePermissions();

  return (
    <RoleGuard hasAccess={canAccessDeliveryNotes} isLoading={isLoading}>
      <DeliveryNotes />
      <Outlet />
    </RoleGuard>
  );
}
